module.exports = __webpack_public_path__ + "img/m2.bb1a5b86.png";